import { render, staticRenderFns } from "./InfoUserModal.vue?vue&type=template&id=a8571e56&scoped=true"
import script from "./InfoUserModal.vue?vue&type=script&lang=ts"
export * from "./InfoUserModal.vue?vue&type=script&lang=ts"
import style0 from "./InfoUserModal.vue?vue&type=style&index=0&id=a8571e56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8571e56",
  null
  
)

export default component.exports